export enum ExecutionStorageLocation {
    Local = 'local',
    Cloud = 'cloud',
}
